import React, { useState, useEffect } from "react";
import NavBar from "../../../components/organisms/navbar";
import Footer from "../../../components/organisms/footer";
import {
  Container,
  Content,
  TournamentContent,
  TournamentDescription,
} from "../styles";
import logoTorneioFacil from "../../../assets/images/branding/logo-torneiofacil.png";

const cacheBuster = `?cacheBuster=${new Date().getTime()}`;

const steps = [
  {
    title: "Faca login na plataforma",
    description: (
      <>
        Acesse:{" "}
        <a href={`https://s1.hmg.torneiofacil.com/login${cacheBuster}`} target="_blank" rel="noopener noreferrer" style={{ color: "var(--red)", fontWeight: 600 }}>
          https://s1.hmg.torneiofacil.com/login
        </a>
        <div style={{ marginTop: 8, padding: "12px 16px", background: "var(--gray-50)", borderRadius: "var(--radius-sm)", border: "1px solid var(--border)" }}>
          <span style={{ display: "block", fontSize: "0.9rem", color: "var(--gray-600)" }}><strong>Usuario:</strong> m4rciete@gmail.com</span>
          <span style={{ display: "block", fontSize: "0.9rem", color: "var(--gray-600)", marginTop: 4 }}><strong>Senha:</strong> TestePagSeguro123@</span>
        </div>
      </>
    ),
  },
  {
    title: "Acesse a pagina de inscricao",
    description: (<>Clique no link abaixo para acessar a inscricao do torneio de teste:{" "}<a href={`https://s1.hmg.torneiofacil.com/enrollment/copa-amizade-de-jiu-jitsu-2024-ginasio-de-esportes-amario-vieira-da-costa-umuarama-pr${cacheBuster}`} target="_blank" rel="noopener noreferrer" style={{ color: "var(--red)", fontWeight: 600, wordBreak: "break-all" }}>Link para inscricao</a></>),
  },
  { title: "Escolha um atleta", description: 'Na opcao "Escolha um atleta para esse evento", selecione MARCIETE FERNADES DELLARMELINA.' },
  { title: "Selecione a categoria", description: "Escolha uma categoria disponivel para o atleta." },
  { title: "Selecione o peso", description: "Escolha o peso correspondente a categoria selecionada." },
  { title: "Selecione a classificacao funcional", description: "Escolha a classificacao funcional do atleta." },
  { title: "Finalize a inscricao", description: "Clique em INSCREVER. Voce sera direcionado para o ambiente de pagamento de teste do PagBank." },
];

const apiEndpoints = [
  { title: "1. Criar Pedido com QR Code PIX", method: "POST", route: "/payments/order", apiPagbank: "POST /orders", arquivo: "create-payment-order.ts", notas: "unit_amount em centavos (R$10,00 = 1000). reference_id = INSC_{enrollmentId}. expiration_date = 30min apos criacao.",
    request: `{\n  "reference_id": "INSC_54779",\n  "customer": {\n    "email": "m4rciete@gmail.com",\n    "name": "thiago souza dellarmelina",\n    "tax_id": "12345678909"\n  },\n  "items": [{\n    "name": "copa amizade de jiu jitsu 2024 - Inscricao No 54779",\n    "quantity": 1, "unit_amount": 1000, "reference_id": "54779"\n  }],\n  "qr_codes": [{ "amount": { "value": 1000 },\n    "expiration_date": "2026-04-09T19:44:20.000-03:00" }],\n  "notification_urls": ["https://api-s1.hmg.torneiofacil.com/payments/webhook"]\n}`,
    response: `{\n  "id": "ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF",\n  "reference_id": "INSC_54779",\n  "created_at": "2026-04-09T19:14:21.246-03:00",\n  "customer": {\n    "name": "thiago souza dellarmelina",\n    "email": "m4rciete@gmail.com",\n    "tax_id": "12345678909"\n  },\n  "items": [{\n    "reference_id": "54779",\n    "name": "copa amizade de jiu jitsu 2024 - Inscricao No 54779",\n    "quantity": 1,\n    "unit_amount": 1000\n  }],\n  "qr_codes": [{\n    "id": "QRCO_030C4249-A66D-40A2-B7C3-474E249CE0FC",\n    "expiration_date": "2026-04-09T19:44:20.000-03:00",\n    "amount": { "value": 1000 },\n    "text": "00020101021226850014br.gov.bcb.pix2563api-h.pagseguro.com/pix/v2/030C4249-A66D-40A2-B7C3-474E249CE0FC27600016BR.COM.PAGSEGURO0136030C4249-A66D-40A2-B7C3-474E249CE0FC520489995303986540510.005802BR5918TORNEIO FACIL LTDA6006Manaus62070503***63048DF1",\n    "arrangements": ["PIX"],\n    "links": [\n      {\n        "rel": "QRCODE.PNG",\n        "href": "https://sandbox.api.pagseguro.com/qrcode/QRCO_030C4249-A66D-40A2-B7C3-474E249CE0FC/png",\n        "media": "image/png",\n        "type": "GET"\n      },\n      {\n        "rel": "QRCODE.BASE64",\n        "href": "https://sandbox.api.pagseguro.com/qrcode/QRCO_030C4249-A66D-40A2-B7C3-474E249CE0FC/base64",\n        "media": "text/plain",\n        "type": "GET"\n      }\n    ]\n  }],\n  "notification_urls": ["https://api-s1.hmg.torneiofacil.com/payments/webhook"],\n  "links": [\n    {\n      "rel": "SELF",\n      "href": "https://sandbox.api.pagseguro.com/orders/ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF",\n      "media": "application/json",\n      "type": "GET"\n    },\n    {\n      "rel": "PAY",\n      "href": "https://sandbox.api.pagseguro.com/orders/ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF/pay",\n      "media": "application/json",\n      "type": "POST"\n    }\n  ]\n}` },
  { title: "2. Consultar Pedido", method: "GET", route: "/payments/order/consult/:orderId", apiPagbank: "GET /orders/{order_id}", arquivo: "pagseguro.service.ts:getOrder()", notas: "Antes do pagamento charges vem vazio []. Apos pagamento, charges[0].status = PAID.",
    request: `GET /orders/ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF\nAuthorization: Bearer {ACCESS_TOKEN_PAYMENT_HOM_ORDER}`,
    response: `{\n  "id": "ORDE_C084F166-...",\n  "charges": [{\n    "id": "CHAR_030C4249-...",\n    "status": "PAID",\n    "paid_at": "2026-04-09T19:14:41.385-03:00",\n    "amount": { "value": 1000, "currency": "BRL" },\n    "payment_response": { "code": "20000", "message": "SUCESSO" },\n    "payment_method": { "type": "PIX",\n      "pix": { "end_to_end_id": "5fd4ea5d324a4267bb2ba1da2795842c" }\n    }\n  }]\n}` },
  { title: "3. Verificar Status (Polling)", method: "GET", route: "/payments/order/status/:enrollmentId", apiPagbank: "Consulta interna + PagBank", arquivo: "payment.controller.ts:checkPaymentStatus()", notas: "Frontend faz polling a cada 1s. Backend verifica local primeiro, depois consulta PagBank.",
    request: `GET /payments/order/status/54779\nAuthorization: Bearer {token}`,
    response: `// Nao pago:\n{ "paid": false, "enrollmentId": 54779 }\n\n// Pago (via webhook):\n{ "paid": true, "enrollmentId": 54779 }\n\n// Pago (detectado via PagBank):\n{ "paid": true, "enrollmentId": 54779, "source": "pagbank_query" }` },
  { title: "4. Webhook PagBank", method: "POST", route: "/payments/webhook", apiPagbank: "Notificacao automatica", arquivo: "payment.controller.ts:webhookPayment()", notas: "Formatos: V1 (legado), Orders API (ORDE_), V2 (charges). Atualiza inscricao quando charges.status = PAID.",
    request: `{\n  "id": "ORDE_C084F166-...",\n  "reference_id": "INSC_54779",\n  "items": [{ "reference_id": "54779", "unit_amount": 1000 }],\n  "charges": [{\n    "id": "CHAR_030C4249-...", "status": "PAID",\n    "payment_method": { "type": "PIX",\n      "pix": { "end_to_end_id": "5fd4ea5d..." } }\n  }]\n}`,
    response: `[\n  { "enrollmentId": 54779, "status": true, "endToEndId": "5fd4ea5d..." }\n]` },
  { title: "5. Pagar Pedido (Cartao)", method: "POST", route: "/orders/{order_id}/pay", apiPagbank: "POST /orders/{id}/pay", arquivo: "pay-order.ts → pagseguro.service.ts:payOrder()", notas: "Usado para pagamento com cartao em 2 etapas. Nao utilizado no fluxo PIX atual.",
    request: `{\n  "charges": [{\n    "amount": { "value": 15500, "currency": "BRL" },\n    "payment_method": { "type": "CREDIT_CARD",\n      "installments": 1, "capture": true,\n      "card": { "encrypted": "<dados>", "store": false },\n      "holder": { "name": "Jose da Silva", "tax_id": "12345678909" }\n    }\n  }]\n}`,
    response: `{\n  "charges": [{\n    "status": "PAID",\n    "payment_response": { "code": "20000", "message": "SUCESSO" },\n    "payment_method": { "type": "CREDIT_CARD",\n      "card": { "brand": "visa", "last_digits": "1111" } }\n  }]\n}` },
];

const logs = [
  { title: "POST /payments/order (Criar Order)", content: `================================================================================
[ORDER ROUTE] Timestamp: 2026-04-09T22:14:21.000Z
[ORDER ROUTE] Recebido enrollmentId: 54779
================================================================================
[CREATE ORDER] Timestamp: 2026-04-09T22:14:21.100Z
[CREATE ORDER] Enrollment IDs: [ 54779 ]
[CREATE ORDER] Token usado: ACCESS_TOKEN_PAYMENT_HOM_ORDER
[CREATE ORDER] Webhook URL: https://api-s1.hmg.torneiofacil.com/payments/webhook
[CREATE ORDER] API URL: https://sandbox.api.pagseguro.com/orders
[CREATE ORDER] Payload enviado ao PagBank: {
  "reference_id": "INSC_54779",
  "customer": {
    "email": "m4rciete@gmail.com",
    "name": "thiago souza dellarmelina",
    "phones": [],
    "tax_id": "12345678909"
  },
  "items": [
    {
      "name": "copa amizade de jiu jitsu 2024 - Inscricao No 54779",
      "quantity": 1,
      "unit_amount": 1000,
      "reference_id": "54779"
    }
  ],
  "qr_codes": [
    {
      "amount": { "value": 1000 },
      "expiration_date": "2026-04-09T19:44:20.000-03:00"
    }
  ],
  "notification_urls": [
    "https://api-s1.hmg.torneiofacil.com/payments/webhook"
  ]
}
[CREATE ORDER] Resposta do PagBank: {
  "id": "ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF",
  "reference_id": "INSC_54779",
  "created_at": "2026-04-09T19:14:21.246-03:00",
  "customer": {
    "name": "thiago souza dellarmelina",
    "email": "m4rciete@gmail.com",
    "tax_id": "12345678909"
  },
  "items": [
    {
      "reference_id": "54779",
      "name": "copa amizade de jiu jitsu 2024 - Inscricao No 54779",
      "quantity": 1,
      "unit_amount": 1000
    }
  ],
  "qr_codes": [
    {
      "id": "QRCO_030C4249-A66D-40A2-B7C3-474E249CE0FC",
      "expiration_date": "2026-04-09T19:44:20.000-03:00",
      "amount": { "value": 1000 },
      "text": "00020101021226850014br.gov.bcb.pix2563api-h.pagseguro.com/pix/v2/030C4249-A66D-40A2-B7C3-474E249CE0FC27600016BR.COM.PAGSEGURO0136030C4249-A66D-40A2-B7C3-474E249CE0FC520489995303986540510.005802BR5918TORNEIO FACIL LTDA6006Manaus62070503***63048DF1",
      "arrangements": ["PIX"],
      "links": [
        {
          "rel": "QRCODE.PNG",
          "href": "https://sandbox.api.pagseguro.com/qrcode/QRCO_030C4249-A66D-40A2-B7C3-474E249CE0FC/png",
          "media": "image/png",
          "type": "GET"
        },
        {
          "rel": "QRCODE.BASE64",
          "href": "https://sandbox.api.pagseguro.com/qrcode/QRCO_030C4249-A66D-40A2-B7C3-474E249CE0FC/base64",
          "media": "text/plain",
          "type": "GET"
        }
      ]
    }
  ],
  "notification_urls": ["https://api-s1.hmg.torneiofacil.com/payments/webhook"],
  "links": [
    {
      "rel": "SELF",
      "href": "https://sandbox.api.pagseguro.com/orders/ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF",
      "media": "application/json",
      "type": "GET"
    },
    {
      "rel": "PAY",
      "href": "https://sandbox.api.pagseguro.com/orders/ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF/pay",
      "media": "application/json",
      "type": "POST"
    }
  ]
}
[CREATE ORDER] Order ID: ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF
[CREATE ORDER] Pagamento salvo no banco. Order ID: ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF
================================================================================
[ORDER ROUTE] Resposta retornada ao frontend. Order ID: ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF
================================================================================` },
  { title: "POST /payments/webhook (PIX Pago)", content: `[WEBHOOK] Notificacao recebida do PagBank: {
  "id": "ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF",
  "reference_id": "INSC_54779",
  "items": [
    {
      "reference_id": "54779",
      "name": "copa amizade de jiu jitsu 2024 - Inscricao No 54779",
      "quantity": 1,
      "unit_amount": 1000
    }
  ],
  "charges": [
    {
      "id": "CHAR_030C4249-A66D-40A2-B7C3-474E249CE0FC",
      "reference_id": "INSC_54779",
      "status": "PAID",
      "created_at": "2026-04-09T19:14:38.854-03:00",
      "paid_at": "2026-04-09T19:14:41.385-03:00",
      "amount": { "value": 1000, "currency": "BRL" },
      "payment_method": {
        "type": "PIX",
        "pix": {
          "notification_id": "NTF_F5B62E52-B1F7-42AE-9612-897B8745E916",
          "end_to_end_id": "5fd4ea5d324a4267bb2ba1da2795842c",
          "holder": {
            "name": "API-PIX Payer Mock",
            "tax_id": "***931180**"
          }
        }
      }
    }
  ]
}
================================================================================
[WEBHOOK ORDER] Notificacao de Order recebida
[WEBHOOK ORDER] Order ID: ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF
[WEBHOOK ORDER] Timestamp: 2026-04-09T22:14:42.000Z
================================================================================
[WEBHOOK V2] Notificacao formato V2 (charges) recebida
[WEBHOOK V2] Timestamp: 2026-04-09T22:14:42.000Z
[WEBHOOK V2] Order ID: ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF
[WEBHOOK V2] Reference ID: INSC_54779
[WEBHOOK V2] Charges: [
  {
    "id": "CHAR_030C4249-A66D-40A2-B7C3-474E249CE0FC",
    "status": "PAID",
    "paid_at": "2026-04-09T19:14:41.385-03:00",
    "amount": { "value": 1000, "currency": "BRL" },
    "payment_method": {
      "type": "PIX",
      "pix": {
        "end_to_end_id": "5fd4ea5d324a4267bb2ba1da2795842c"
      }
    }
  }
]
[WEBHOOK V2] Items: [
  {
    "reference_id": "54779",
    "name": "copa amizade de jiu jitsu 2024 - Inscricao No 54779",
    "quantity": 1,
    "unit_amount": 1000
  }
]
[WEBHOOK V2] Charge PAID encontrada: {
  "id": "CHAR_030C4249-A66D-40A2-B7C3-474E249CE0FC",
  "status": "PAID",
  "paid_at": "2026-04-09T19:14:41.385-03:00",
  "amount": { "value": 1000, "currency": "BRL" },
  "payment_method": {
    "type": "PIX",
    "pix": {
      "end_to_end_id": "5fd4ea5d324a4267bb2ba1da2795842c"
    }
  }
}
[WEBHOOK V2] Metodo de pagamento: {
  "type": "PIX",
  "pix": {
    "notification_id": "NTF_F5B62E52-B1F7-42AE-9612-897B8745E916",
    "end_to_end_id": "5fd4ea5d324a4267bb2ba1da2795842c",
    "holder": {
      "name": "API-PIX Payer Mock",
      "tax_id": "***931180**"
    }
  }
}
[WEBHOOK V2] Atualizando inscricao: {
  "enrollmentId": 54779,
  "status": true,
  "endToEndId": "5fd4ea5d324a4267bb2ba1da2795842c"
}
[WEBHOOK V2] Inscricoes atualizadas com sucesso. Total: 1
[WEBHOOK V2] Resultados: [
  { "enrollmentId": 54779, "status": true }
]
================================================================================` },
  { title: "GET /payments/order/status (Polling)", content: `[CHECK STATUS] Timestamp: 2026-04-09T22:14:47.000Z
[CHECK STATUS] Inscricao 54779 - status local: false - paidAuto: null
[CHECK STATUS] Consultando order no PagBank: ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF
[GET ORDER] Consultando order: ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF
[GET ORDER] Resposta: {
  "id": "ORDE_C084F166-8CB6-46C0-911D-E8E568D593FF",
  "reference_id": "INSC_54779",
  "charges": [
    {
      "id": "CHAR_030C4249-A66D-40A2-B7C3-474E249CE0FC",
      "reference_id": "INSC_54779",
      "status": "PAID",
      "created_at": "2026-04-09T19:14:38.854-03:00",
      "paid_at": "2026-04-09T19:14:41.385-03:00",
      "amount": {
        "value": 1000,
        "currency": "BRL",
        "summary": { "total": 1000, "paid": 1000, "refunded": 0, "incremented": 0 }
      },
      "payment_response": { "code": "20000", "message": "SUCESSO" },
      "payment_method": {
        "type": "PIX",
        "pix": {
          "notification_id": "NTF_F5B62E52-B1F7-42AE-9612-897B8745E916",
          "end_to_end_id": "5fd4ea5d324a4267bb2ba1da2795842c",
          "holder": { "name": "API-PIX Payer Mock", "tax_id": "***931180**" }
        }
      }
    }
  ]
}
[CHECK STATUS] Status charges PagBank: [
  { "id": "CHAR_030C4249-A66D-40A2-B7C3-474E249CE0FC", "status": "PAID" }
]
[CHECK STATUS] PagBank confirmou PAID! Atualizando inscricao...
[CHECK STATUS] Charge PAID: {
  "id": "CHAR_030C4249-A66D-40A2-B7C3-474E249CE0FC",
  "status": "PAID",
  "payment_method": {
    "type": "PIX",
    "pix": { "end_to_end_id": "5fd4ea5d324a4267bb2ba1da2795842c" }
  }
}
[CHECK STATUS] Inscricao atualizada para PAGO via consulta PagBank.` },
];

const testResults = [
  { step: "Login", status: "ok", detail: "Token JWT recebido" },
  { step: "Inscricao #54779", status: "ok", detail: "Atleta thiago, faixa preta, R$10" },
  { step: "Criar Order PIX", status: "ok", detail: "ORDE_C084F166-..., QR Code gerado" },
  { step: "Pagamento sandbox", status: "ok", detail: "PAID em ~20s (auto < R$100)" },
  { step: "Polling status", status: "ok", detail: "Detectou pagamento na 2a consulta" },
];

const flowPhases = [
  { num: 1, title: "Inscricao", color: "#1565c0", bg: "#e3f2fd", from: "Frontend", to: "Backend", arrow: "POST /tournaments/enrollment/{slug}", desc: "Usuario preenche formulario e clica em Inscrever. Backend cria inscricao com status: false e retorna o ID." },
  { num: 2, title: "Criacao do Pedido PIX", color: "#e65100", bg: "#fff3e0", from: "Backend", to: "PagBank API", arrow: "POST /orders { items, qr_codes }", desc: "Backend monta payload com items (centavos), customer, qr_codes (expiracao 30min) e notification_urls. PagBank retorna ORDE_ ID e QR Code PIX." },
  { num: 3, title: "Pagamento", color: "#2e7d32", bg: "#e8f5e9", from: "Usuario", to: "App do Banco", arrow: "Escaneia QR Code / Cola PIX", desc: "Frontend exibe QR Code com timer de 10 minutos. Usuario escaneia ou cola o codigo PIX no app do banco." },
  { num: 4, title: "Webhook (confirmacao)", color: "#6a1b9a", bg: "#f3e5f5", from: "PagBank", to: "Backend", arrow: "POST /webhook { charges: PAID }", desc: "PagBank envia notificacao com charges.status: PAID. Backend atualiza status: true no banco." },
  { num: 5, title: "Polling (fallback)", color: "#c62828", bg: "#ffebee", from: "Frontend", to: "Backend + PagBank", arrow: "GET /status/:id (a cada 1s)", desc: "Frontend faz polling. Backend verifica local, se nao pago consulta PagBank. Detecta PAID e retorna { paid: true }." },
];

const sandboxBehavior = [
  { valor: "Ate R$100,00", comportamento: "Pago instantaneamente" },
  { valor: "R$100,01 a R$200,00", comportamento: "Pago com delay de ~5 minutos" },
  { valor: "Acima de R$200,00", comportamento: "Fica aguardando" },
];

const S: Record<string, React.CSSProperties> = {
  secTitle: { fontFamily: "var(--font-display)", fontSize: "1.3rem", fontWeight: 800, color: "var(--navy)", textTransform: "uppercase", letterSpacing: "0.03em", marginBottom: 16, marginTop: 0 },
  card: { background: "var(--card-bg)", borderRadius: "var(--radius-md)", border: "1px solid var(--border)", boxShadow: "var(--shadow-sm)", padding: "20px 24px", marginBottom: 16 },
  code: { background: "#1e1e2e", color: "#cdd6f4", borderRadius: "var(--radius-sm)", padding: "16px", fontSize: "0.78rem", fontFamily: "var(--font-mono)", overflow: "hidden", whiteSpace: "pre-wrap", wordBreak: "break-word", overflowWrap: "anywhere", lineHeight: 1.5, marginTop: 8 },
  btn: { display: "flex", alignItems: "center", justifyContent: "center", gap: 10, padding: "16px 24px", color: "#fff", borderRadius: "var(--radius-sm)", textDecoration: "none", fontFamily: "var(--font-body)", fontWeight: 700, fontSize: "0.95rem", letterSpacing: "0.02em", transition: "var(--transition)", boxShadow: "var(--shadow-md)", border: "none", cursor: "pointer", width: "100%" },
};

const badge = (c: string, bg: string): React.CSSProperties => ({ display: "inline-block", padding: "2px 10px", borderRadius: 6, fontWeight: 700, fontSize: "0.7rem", letterSpacing: "0.04em", color: c, background: bg, textTransform: "uppercase", fontFamily: "var(--font-display)" });

const InstrucaoTestePagbank: React.FC = () => {
  const [showDocs, setShowDocs] = useState(false);

  useEffect(() => {
    document.body.style.overflow = showDocs ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [showDocs]);

  return (
    <>
      <NavBar />
      <Container>
        <TournamentContent>
          <Content>
            <div style={{ maxWidth: 720, margin: "0 auto", paddingBottom: 24 }}>
              <h1 style={{ fontFamily: "var(--font-display)", fontSize: "clamp(1.5rem, 4vw, 2.2rem)", fontWeight: 800, color: "var(--navy)", margin: 0, textTransform: "uppercase", letterSpacing: "0.04em" }}>Instrucao para Teste de Pagamento</h1>
              <p style={{ color: "var(--gray-500)", fontSize: "1rem", marginTop: 8, fontFamily: "var(--font-body)" }}>Siga o passo a passo abaixo para realizar um teste de pagamento no ambiente de homologacao.</p>
            </div>

            <div style={{ maxWidth: 720, margin: "0 auto", paddingBottom: 32, display: "flex", gap: 12, flexWrap: "wrap" }}>
              <a href="http://logs-staging.torneiofacil.com/container/8977623234fd" target="_blank" rel="noopener noreferrer" style={{ ...S.btn, background: "var(--navy)", flex: 1, minWidth: 200 }}>
                <span style={{ fontSize: "1.2rem" }}>&#9654;</span> Ver Logs (Backend e Frontend)
              </a>
              <button onClick={() => setShowDocs(!showDocs)} style={{ ...S.btn, background: showDocs ? "var(--gray-700)" : "var(--red)", flex: 1, minWidth: 200 }}>
                <span style={{ fontSize: "1.1rem" }}>{showDocs ? "\u2715" : "\u2630"}</span>
                {showDocs ? "Fechar Documentacao" : "Documentacao da API PagBank"}
              </button>
            </div>

            {showDocs && (
              <>
              {/* Overlay */}
              <div onClick={() => setShowDocs(false)} style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.6)", zIndex: 9998, backdropFilter: "blur(4px)" }} />
              {/* Modal */}
              <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "min(95vw, 960px)", height: "90vh", background: "var(--bg-page, #f3f4f8)", zIndex: 9999, overflowY: "auto", boxShadow: "var(--shadow-2xl, 0 25px 50px rgba(0,0,0,.25))", padding: "0 32px 40px", borderRadius: "var(--radius-lg, 16px)", scrollbarWidth: "none", msOverflowStyle: "none" }}>
                <style>{`div::-webkit-scrollbar { display: none; }`}</style>
                {/* Header fixo */}
                <div style={{ position: "sticky", top: 0, background: "var(--bg-page, #f3f4f8)", zIndex: 1, padding: "24px 0 16px", borderBottom: "1px solid var(--border)", marginBottom: 24, display: "flex", justifyContent: "space-between", alignItems: "center", borderRadius: "var(--radius-lg, 16px) var(--radius-lg, 16px) 0 0" }}>
                  <h2 style={{ fontFamily: "var(--font-display)", fontSize: "1.4rem", fontWeight: 800, color: "var(--navy)", textTransform: "uppercase", letterSpacing: "0.04em", margin: 0 }}>Documentacao API PagBank</h2>
                  <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <button onClick={() => {
                      const content = document.getElementById("docs-modal-content");
                      if (!content) return;
                      const win = window.open("", "_blank");
                      if (!win) return;
                      win.document.write(`<!DOCTYPE html><html><head><title>Documentacao API PagBank</title><style>
                        * { margin: 0; padding: 0; box-sizing: border-box; }
                        body { font-family: 'Barlow', 'Inter', sans-serif; padding: 32px; color: #1a2252; background: #fff; }
                        h2 { font-family: 'Barlow Condensed', sans-serif; font-size: 1.3rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.03em; margin: 24px 0 12px; color: #1a2252; }
                        pre { background: #1e1e2e; color: #cdd6f4; border-radius: 8px; padding: 16px; font-size: 0.7rem; font-family: 'JetBrains Mono', monospace; white-space: pre-wrap !important; word-wrap: break-word !important; word-break: break-all !important; overflow-wrap: anywhere !important; overflow: visible !important; max-width: 100% !important; max-height: none !important; line-height: 1.5; margin: 8px 0; }
                        table { width: 100%; border-collapse: collapse; font-size: 0.85rem; margin-bottom: 16px; }
                        th { background: #1a2252; color: #fff; padding: 10px 16px; text-align: left; }
                        td { padding: 10px 16px; border-bottom: 1px solid #eee; }
                        @media print { body { padding: 12px; } pre { font-size: 0.62rem !important; white-space: pre-wrap !important; word-break: break-all !important; overflow-wrap: anywhere !important; overflow: visible !important; max-width: 100% !important; max-height: none !important; page-break-inside: auto !important; break-inside: auto !important; } * { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
                      </style></head><body>${content.innerHTML}</body></html>`);
                      win.document.close();
                      win.focus();
                      win.print();
                    }} style={{ background: "var(--navy)", border: "none", borderRadius: "var(--radius-sm)", padding: "8px 16px", display: "flex", alignItems: "center", gap: 6, cursor: "pointer", color: "#fff", fontSize: "0.8rem", fontWeight: 700, fontFamily: "var(--font-body)", transition: "var(--transition)" }}>
                      <span style={{ fontSize: "1rem" }}>&#128424;</span> Imprimir
                    </button>
                    <button onClick={() => setShowDocs(false)} style={{ background: "var(--gray-200)", border: "none", borderRadius: "50%", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: "1.2rem", color: "var(--gray-700)", transition: "var(--transition)" }}>{"\u2715"}</button>
                  </div>
                </div>
              <div id="docs-modal-content" style={{ maxWidth: 900, margin: "0 auto", paddingBottom: 40 }}>
                {/* Cabecalho com logo */}
                <div style={{ display: "flex", alignItems: "center", gap: 16, padding: "20px 0 24px", borderBottom: "2px solid var(--navy, #1a2252)", marginBottom: 28 }}>
                  <img src={logoTorneioFacil} alt={"Torneio F\u00e1cil"} style={{ height: 50, objectFit: "contain" }} />
                  <div>
                    <h2 style={{ fontFamily: "var(--font-display)", fontSize: "1.2rem", fontWeight: 800, color: "var(--navy)", textTransform: "uppercase", letterSpacing: "0.04em", margin: 0 }}>{"Torneio F\u00e1cil"}</h2>
                    <p style={{ fontFamily: "var(--font-body)", fontSize: "0.8rem", color: "var(--gray-500)", margin: 0 }}>{"Documenta\u00e7\u00e3o de Integra\u00e7\u00e3o PagBank - API de Pedidos e Pagamentos (Order)"}</p>
                  </div>
                </div>

                <h2 style={S.secTitle}>Fluxo Completo - Pagamento PIX (API de Pedidos e Pagamentos (Order))</h2>
                <div style={{ display: "flex", flexDirection: "column", marginBottom: 32 }}>
                  {flowPhases.map((p, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "stretch" }}>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 48, flexShrink: 0 }}>
                        <div style={{ width: 36, height: 36, borderRadius: "50%", background: p.color, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: "0.95rem", fontFamily: "var(--font-display)", zIndex: 1 }}>{p.num}</div>
                        {i < flowPhases.length - 1 && <div style={{ width: 3, flex: 1, background: "var(--gray-200)" }} />}
                      </div>
                      <div style={{ ...S.card, borderLeft: `4px solid ${p.color}`, background: p.bg, flex: 1, marginLeft: 12 }}>
                        <h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: p.color }}>{p.title}</h3>
                        <div style={{ marginTop: 4, display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                          <span style={badge("#fff", p.color)}>{p.from}</span>
                          <span style={{ color: "var(--gray-400)" }}>&#8594;</span>
                          <span style={badge("#fff", p.color)}>{p.to}</span>
                          <code style={{ fontSize: "0.75rem", color: "var(--gray-600)", background: "rgba(255,255,255,0.7)", padding: "2px 8px", borderRadius: 4 }}>{p.arrow}</code>
                        </div>
                        <p style={{ margin: "10px 0 0", fontSize: "0.85rem", color: "var(--gray-700)", lineHeight: 1.6 }}>{p.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <h2 style={S.secTitle}>Sandbox - Comportamento PIX</h2>
                <div style={{ ...S.card, marginBottom: 32, padding: 0, overflow: "hidden" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.85rem", fontFamily: "var(--font-body)" }}>
                    <thead><tr style={{ background: "var(--navy)", color: "#fff" }}><th style={{ padding: "10px 16px", textAlign: "left" }}>Valor</th><th style={{ padding: "10px 16px", textAlign: "left" }}>Comportamento</th></tr></thead>
                    <tbody>{sandboxBehavior.map((r, i) => (<tr key={i} style={{ borderBottom: "1px solid var(--border)" }}><td style={{ padding: "10px 16px", fontWeight: 600 }}>{r.valor}</td><td style={{ padding: "10px 16px" }}>{r.comportamento}</td></tr>))}</tbody>
                  </table>
                </div>

                <h2 style={S.secTitle}>Endpoints da API</h2>
                {apiEndpoints.map((ep, i) => (
                  <div key={i} style={{ ...S.card, marginBottom: 20 }}>
                    <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                      <span style={badge("#fff", ep.method === "POST" ? "#2e7d32" : "#1565c0")}>{ep.method}</span>
                      <h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: "var(--navy)" }}>{ep.title}</h3>
                    </div>
                    <div style={{ marginTop: 8, fontSize: "0.8rem", color: "var(--gray-500)", lineHeight: 1.6 }}>
                      <div><strong>Rota:</strong> <code style={{ background: "var(--gray-50)", padding: "1px 6px", borderRadius: 4 }}>{ep.route}</code></div>
                      <div><strong>PagBank:</strong> <code style={{ background: "var(--gray-50)", padding: "1px 6px", borderRadius: 4 }}>{ep.apiPagbank}</code></div>
                      <div><strong>Arquivo:</strong> <code style={{ background: "var(--gray-50)", padding: "1px 6px", borderRadius: 4 }}>{ep.arquivo}</code></div>
                    </div>
                    {ep.notas && <div style={{ marginTop: 10, padding: "8px 12px", background: "#fffde7", borderRadius: "var(--radius-sm)", border: "1px solid #fff9c4", fontSize: "0.78rem", color: "#795548", lineHeight: 1.5 }}>{ep.notas}</div>}
                    <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 12 }}>
                      <div><div style={{ fontSize: "0.75rem", fontWeight: 700, color: "var(--gray-500)", textTransform: "uppercase", marginBottom: 4 }}>Request</div><pre style={S.code}>{ep.request}</pre></div>
                      <div><div style={{ fontSize: "0.75rem", fontWeight: 700, color: "var(--gray-500)", textTransform: "uppercase", marginBottom: 4 }}>Response</div><pre style={S.code}>{ep.response}</pre></div>
                    </div>
                  </div>
                ))}

                <h2 style={S.secTitle}>Logs do Backend (Teste Real)</h2>
                {logs.map((l, i) => (
                  <div key={i} style={{ ...S.card, marginBottom: 16 }}>
                    <h3 style={{ margin: 0, fontSize: "0.9rem", fontWeight: 700, color: "var(--navy)" }}>{l.title}</h3>
                    <pre style={{ ...S.code, background: "#0d1117", color: "#7ee787", maxHeight: "none" }}>{l.content}</pre>
                  </div>
                ))}

                <h2 style={S.secTitle}>Resultado do Teste E2E (09/04/2026)</h2>
                <div style={{ ...S.card, padding: 0, overflow: "hidden", marginBottom: 32 }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.85rem", fontFamily: "var(--font-body)" }}>
                    <thead><tr style={{ background: "var(--navy)", color: "#fff" }}><th style={{ padding: "10px 16px", textAlign: "left" }}>Etapa</th><th style={{ padding: "10px 16px", textAlign: "center", width: 80 }}>Status</th><th style={{ padding: "10px 16px", textAlign: "left" }}>Detalhe</th></tr></thead>
                    <tbody>{testResults.map((r, i) => (
                      <tr key={i} style={{ borderBottom: "1px solid var(--border)" }}>
                        <td style={{ padding: "10px 16px", fontWeight: 600 }}>{r.step}</td>
                        <td style={{ padding: "10px 16px", textAlign: "center" }}><span style={badge("#fff", r.status === "ok" ? "#2e7d32" : "#c62828")}>{r.status === "ok" ? "OK" : "BUG"}</span></td>
                        <td style={{ padding: "10px 16px", fontSize: "0.82rem", color: "var(--gray-600)" }}>{r.detail}</td>
                      </tr>
                    ))}</tbody>
                  </table>
                </div>

                <h2 style={S.secTitle}>Configuracao</h2>
                <div style={{ ...S.card, padding: 0, overflow: "hidden" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.82rem", fontFamily: "var(--font-body)" }}>
                    <thead><tr style={{ background: "var(--navy)", color: "#fff" }}><th style={{ padding: "10px 16px", textAlign: "left" }}>Variavel</th><th style={{ padding: "10px 16px", textAlign: "left" }}>Descricao</th></tr></thead>
                    <tbody>{[
                      ["API_URL_PAYMENT_SERVICE", "sandbox.api.pagseguro.com (sandbox) / api.pagseguro.com (prod)"],
                      ["ACCESS_TOKEN_PAYMENT_HOM_ORDER", "Token exclusivo para rota de Orders (homologacao)"],
                      ["ACCESS_TOKEN_PAYMENT", "Token principal de pagamento"],
                      ["PAYMENT_WEBHOOK_URL", "URL do webhook para notificacoes do PagBank"],
                    ].map(([k, v], i) => (
                      <tr key={i} style={{ borderBottom: "1px solid var(--border)" }}>
                        <td style={{ padding: "10px 16px" }}><code style={{ fontSize: "0.78rem" }}>{k}</code></td>
                        <td style={{ padding: "10px 16px" }}>{v}</td>
                      </tr>
                    ))}</tbody>
                  </table>
                </div>
                <div style={{ marginTop: 24, fontSize: "0.8rem", color: "var(--gray-400)", textAlign: "center" }}>
                  Referencia: <a href="https://dev.pagbank.uol.com.br/reference/criar-pagar-pedido-com-cartao" target="_blank" rel="noopener noreferrer" style={{ color: "var(--gray-500)" }}>PagBank Orders API</a>
                </div>
              </div>
              </div>
              </>
            )}

            <TournamentDescription style={{ padding: "0 0 60px" }}>
              <div style={{ maxWidth: 720, margin: "0 auto", display: "flex", flexDirection: "column", gap: 20 }}>
                {steps.map((step, i) => (
                  <div key={i} style={{ display: "flex", gap: 16, alignItems: "flex-start", padding: "20px 24px", background: "var(--card-bg)", borderRadius: "var(--radius-md)", border: "1px solid var(--border)", boxShadow: "var(--shadow-sm)" }}>
                    <div style={{ minWidth: 36, height: 36, borderRadius: "50%", background: i === steps.length - 1 ? "var(--red)" : "var(--navy)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: "0.95rem", fontFamily: "var(--font-display)", flexShrink: 0 }}>{i + 1}</div>
                    <div>
                      <h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: "var(--navy)" }}>{step.title}</h3>
                      <div style={{ marginTop: 6, fontSize: "0.9rem", color: "var(--gray-600)", lineHeight: 1.6 }}>{step.description}</div>
                    </div>
                  </div>
                ))}
              </div>
            </TournamentDescription>
          </Content>
        </TournamentContent>
      </Container>
      <Footer />
    </>
  );
};

export default InstrucaoTestePagbank;
